import React, {useState} from 'react'
import _ from "lodash";
import {DocumentArrowUpIcon} from "@heroicons/react/24/solid";
import {addTags} from "../common/services/tag-data-service";
import ShowMessage from "../common/ui/show-message";
import {prepareTextListForSearch} from "../common/utils/text-util";
import ShowLink from "../common/ui/show-link";


const AddTagDetails = () => {
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    const [inputText, setInputText] = useState('');
    const [textItemList, setTextItemList] = useState([]);

    const handleInputTextChange = (newValue) => {
        setInputText(newValue);

        const inputTextItems = _.split(newValue, '\n');
        const tempTextItemList = [];

        _.forEach(inputTextItems, (text, index) => {
            text = text.trim();

            if (text) {
                let changedText = _.startCase(text);
                let textList = prepareTextListForSearch(text);

                // console.log({textList})

                tempTextItemList.push({
                    text: text,
                    textList: textList,
                    startText: changedText,
                    displayText: changedText,
                });
            }
        });

        setTextItemList(tempTextItemList);
    };

    const saveTags = async () => {
        await addTags(textItemList);
        setIsSuccess(true);
    }

    return (
        <>

            <div className="justify-center bg-gray-200 rounded dashboard-container">
                <div className="">
                    <ShowMessage
                        isSuccess={isSuccess}
                        isError={isError}
                        message={'Tags Added Successfully.'}/>
                </div>

                <div className="flex justify-center bg-gray-200 rounded dashboard-container">
                    <div className="items-center justify-start w-1/2 p-8 mb-16">
                        <div className="flex justify-start items-center mb-8">
                            <ShowLink label="Back"
                                      url="/tags"/>
                            <div className="text-xl ml-4">
                                Tags
                            </div>
                        </div>
                        <textarea
                            id="inputText"
                            name="inputText"
                            value={inputText}
                            onChange={(event) => handleInputTextChange(event.target.value)}
                            className="w-full h-full border border-slate-400 rounded p-2 -mt-2"/>
                    </div>

                    <div className="items-center justify-start w-1/2 pb-16 mr-8 my-8">

                        <div className="flex items-center w-full mb-4">
                            <div className="font-bold">Prepared Tags</div>
                            <div className="ml-4">
                                <button
                                    onClick={() => {
                                        saveTags()
                                    }}
                                    className="rounded flex items-center justify-center bg-green-600 text-white border border-green-600 text-gray-800 h-10 hover:bg-gray-600 hover:text-white">
                                    <div className="pl-2">
                                        <DocumentArrowUpIcon className="h-6 w-6"/>
                                    </div>
                                    <div className="p-2">Save Tags</div>
                                </button>
                            </div>
                        </div>

                        <div className="overflow-y-scroll h-full border border-gray-400 rounded bg-white px-4">
                            <div className="py-4">
                                {textItemList?.map((textItem, index) => (
                                    <div key={index}>
                                        {index !== textItemList?.length - 1 ?
                                            <div className="py-2 border-b border-gray-400"><span
                                                className="px-4 text-gray-600">{index + 1}</span>{textItem.text}
                                            </div>
                                            : <div className="py-2"><span
                                                className="px-4 text-gray-600">{index + 1}</span>{textItem.text}
                                            </div>
                                        }
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}

export default AddTagDetails
